const letters = {
    "\u2764": require('./_heart.jpg'),
    _space: [
        require('./_space_blue.jpg'), 
        require('./_space_green.jpg'), 
        require('./_space_red.jpg') ,
        require('./_space_yellow.jpg')
    ],
    "!": require("./_bang.jpg"),
    ",": require("./_comma.jpg"),
    ".": require("./_period.jpg"),
    "'": require("./_apostrophe.jpg"),
    "’": require("./_apostrophe.jpg"),
    "*": require("./_astersk.jpg"),
    "@": require("./_at.jpg"),
    "&": require("./_ampersand.jpg"),
    "$": require("./_dollar.jpg"),
    "%": require("./_percent.jpg"),
    "#": require("./_octothorpe.jpg"),
    "“": require("./_left_quote.jpg"),
    "”": require("./_right_quote.jpg"),
    "?": require("./_question.jpg"),
    "+": require("./_plus.jpg"),
    "=": require("./_equals.jpg"),
    "-": require("./_dash.jpg"),
    "…": require("./_ellipsis.jpg"),
    "~": require("./_tilde.jpg"),
    "\\": require("./_backslash.jpg"),
    "|": require("./_pipe.jpg"),
    "/": require("./_slash.jpg"),
    A: require("./A.jpg"),
    B: require("./B.jpg"),
    C: require("./C.jpg"),
    D: require("./D.jpg"),
    E: require("./E.jpg"),
    F: require("./F.jpg"),
    G: require("./G.jpg"),
    H: require("./H.jpg"),
    I: require("./I.jpg"),
    J: require("./J.jpg"),
    K: require("./K.jpg"),
    L: require("./L.jpg"),
    M: require("./M.jpg"),
    N: require("./N.jpg"),
    O: require("./O.jpg"),
    P: require("./P.jpg"),
    Q: require("./Q.jpg"),
    R: require("./R.jpg"),
    S: require("./S.jpg"),
    T: require("./T.jpg"),
    U: require("./U.jpg"),
    V: require("./V.jpg"),
    W: require("./W.jpg"),
    X: require("./X.jpg"),
    Y: require("./Y.jpg"),
    Z: require("./Z.jpg"),
    "0": require("./0.jpg"),
    "1": require("./1.jpg"),
    "2": require("./2.jpg"),
    "3": require("./3.jpg"),
    "4": require("./4.jpg"),
    "5": require("./5.jpg"),
    "6": require("./6.jpg"),
    "7": require("./7.jpg"),
    "8": require("./8.jpg"),
    "9": require("./9.jpg")
}

export default letters;


// WEBPACK FOOTER //
// ./src/alphabet/letters.js